/**
 * Shared money/integer helpers for the Adesa Run List working sheet.
 * Used by AuctionRunTable (computed + reference columns) and
 * VehicleDetailModal (display + editable money inputs) so they render and
 * parse numbers identically. Extracted per frontend-standards §4 to avoid
 * the same logic drifting across components.
 */

// Round to whole dollars and render as "$1,234" / "-$1,234". null/undefined
// (no value) renders blank, matching every other reference cell in the table.
export function formatMoney(value: number | null | undefined): string {
  if (value == null) return ""
  const rounded = Math.round(value)
  const sign = rounded < 0 ? "-" : ""
  return `${sign}$${Math.abs(rounded).toLocaleString()}`
}

// Round to a whole number with thousands separators; blank when absent.
export function formatInt(value: number | null | undefined): string {
  if (value == null) return ""
  return Math.round(value).toLocaleString()
}

// Parse a user-typed money string ("$1,234", "1,234", "1234", "") into a
// number. Blank/whitespace → null (a cleared field). Unparseable input →
// NaN so the caller can surface a validation error before saving.
export function parseMoney(raw: string): number | null {
  const trimmed = raw.trim()
  if (trimmed === "") return null
  const cleaned = trimmed.replace(/[$,\s]/g, "")
  return Number(cleaned) // NaN when not a number — caller checks
}
